import { css } from '@emotion/core';
import { variables as vars } from '@domain-group/fe-brary';
import { rgba } from 'polished';
var colour = vars.colour,
  font = vars.font,
  global = vars.global;
export var popup = /*#__PURE__*/css("display:inline-block;position:absolute;border:1px solid ", colour.neutral100, ";pointer-events:auto;background-color:", colour.white, ";box-shadow:0 1px 8px 0 ", rgba(colour.black, 0.15), ";z-index:", global.layerFloating + 1, ";min-width:230px;min-height:230px;width:230px;right:auto;top:0;left:0;&::after,&::before{bottom:100%;left:50%;border:solid transparent;content:' ';height:0;width:0;position:absolute;pointer-events:none;border-color:", rgba(colour.white, 0), ";}&::before{border-bottom-color:", colour.neutral200, ";border-width:10px;margin-left:-10px;top:-21px;}&::after{border-bottom-color:", colour.white, ";border-width:10px;margin-left:-10px;}");
export var title = /*#__PURE__*/css("margin-top:33px;text-align:center;color:", colour.neutral - 600, ";font-family:", font.bodyFontFamily, ";font-size:", font.baseFontSize, ";font-weight:600;");
export var message = /*#__PURE__*/css("text-align:center;color:", colour.neutral - 600, ";font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";margin:auto 20px;line-height:", font.baseLineHeight, ";");
export var arrowPosition = position => /*#__PURE__*/css("&::after,&::before{left:", position, "px;}");
export var hasText = {
  name: "260zpl",
  styles: "left:0;"
};
export var squeezed = {
  name: "1qfpe10",
  styles: "min-height:184px;height:fit-content;"
};
export var squeezedTitle = {
  name: "1xaekgw",
  styles: "margin-top:20px;"
};
export var squeezedMessage = {
  name: "4g9xqe",
  styles: "line-height:normal;"
};
export var closeButton = /*#__PURE__*/css("position:absolute;top:8px;right:8px;background:none;border:0;color:", colour.neutral700, ";");
export var buttonGroup = {
  name: "1yuhvjn",
  styles: "margin-top:16px;"
};
export var buttonWrapper = {
  name: "127jhi8",
  styles: "text-align:center;width:100%;"
};
export var button = {
  name: "m7q6f4",
  styles: "width:190px;"
};